import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';
import { CompanySignUp, CompanySignUpPage, CompanySignUpRequest } from '../../model';
import { RegistrationNumberInputCheckResult, TaxCodeInputCheckResult } from '../../model/misc.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService
  ) {}

  searchSignupWorksites(props: CompanySignUpRequest): Observable<CompanySignUpPage> {
    const headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true);
    const url = this.occEndpointsService.buildUrl('signupWorksites', {
      queryParams: {
        count: props.count || 10,
        page: props.page || 0,
        countryCode: props.countryCode || null,
        fulltext: props.fulltext,
        searchTerm: props.searchTerm,
        isEmail: props.isEmail || false,
      },
    });
    return this.httpClient.get<CompanySignUpPage>(url, { headers });
  }

  getSignupWorksiteByCompanyId(id: string, companySearchServiceType?: string): Observable<CompanySignUp> {
    const headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true);
    const url = this.occEndpointsService.buildUrl('signupWorksite', {
      urlParams: { id: id },
      queryParams: {
        searchType: companySearchServiceType || null,
      },
    });
    return this.httpClient.get<CompanySignUp>(url, { headers });
  }

  validateRegistrationNumber(registrationNumber: string): Observable<RegistrationNumberInputCheckResult> {
    const url = this.occEndpointsService.buildUrl('registrationNumberCheck', {
      queryParams: { registrationNumber: registrationNumber },
    });
    const headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true);
    return this.httpClient.get(url, { headers }).pipe(
      mapTo({ valid: true, message: '' }),
      catchError((res) => {
        return of({ valid: false, message: res.error?.errors[0]?.message });
      })
    );
  }

  validateTaxCode(taxCode: string, countryIsoCode: string): Observable<TaxCodeInputCheckResult> {
    const url = this.occEndpointsService.buildUrl('taxCodeCheck', {
      queryParams: { taxCode, countryIsocode: countryIsoCode },
    });
    const headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true);
    return this.httpClient.get(url, { headers }).pipe(
      mapTo({ valid: true, message: '' }),
      catchError((res) => {
        return of({ valid: false, message: res.error?.errors[0]?.message });
      })
    );
  }
}
